<template id="directory-page">
    <div>
        <div id="filter-header">
            <div class="left">
                <div class="filter">
                    <StartingSoonFilter :initialFilterApplied="startingSoon" />
                    <BiggestPotFilter :initialFilterApplied="biggestPot" />
                </div>
            </div>
            <div class="right">
                <ModalFilter
                  :initialTeamSize="teamSize"
                  :initialChallengeType="challengeType"
                />
            </div>
        </div>
        <div id="directory-content" v-if="dataLoaded">
            <PromoChallengeCards />
            <HealthyWagerCards v-bind:hwagerExclude="hwagerExclude"
                               v-bind:corporateChallengeUrl="corporateChallengeUrl" />
            <ChallengesCards />
        </div>
    </div>
</template>

<script>
import StartingSoonFilter from './StartingSoonFilter';
import BiggestPotFilter from './BiggestPotFilter';
import PromoChallengeCards from './PromoChallengeCards';
import HealthyWagerCards from './HealthyWagerCards';
import ChallengesCards from './ChallengesCards';
import ModalFilter from './ModalFilter';
import { variables } from './constants';

const CHALLENGE_DIRECTORY_API_URL = window.location.origin + '/api/challenges/directory/';
const CHALLENGE_DIRECTORY_API_V9_URL = window.location.origin + '/api/v5.1/challenge_directory';

export default {
  template: '#directory-page',
  components: { StartingSoonFilter, BiggestPotFilter, ModalFilter, PromoChallengeCards, HealthyWagerCards, ChallengesCards },
  data: function() {
    return {
      dataLoaded: false,
      corporate_challenge_url: '',
      hwagerExclude: false,
      nyop_challenge: {},
      user: {},
      teamSize: '',
      challengeType: '',
      biggestPot: false,
      startingSoon: false
    }
  },
  methods: {
    setFiltersInitialFilters: function (parameters) {
      if (parameters && typeof (parameters) === 'object' && parameters.filters && typeof (parameters.filters) === 'string') {
        // Modal filters
        const team = parameters.filters.includes(variables.TEAM);
        const individual = parameters.filters.includes(variables.INDIVIDUAL);
        const step = parameters.filters.includes(variables.STEP);
        const weightLoss = parameters.filters.includes(variables.WEIGHT_LOSS);

        const teamSize = team ? variables.TEAM : individual ? variables.INDIVIDUAL : '';
        const challengeType = step ? variables.STEP : weightLoss ? variables.WEIGHT_LOSS : '';

        this.teamSize = teamSize;
        this.challengeType = challengeType;

        // Ensure state update for Modal filters is completed before moving to Quick filters
        this.$nextTick(() => {
          // Quick filters
          const startingSoon = parameters.filters.includes('startingSoon');
          const biggestPot = parameters.filters.includes('biggestPot');

          this.biggestPot = biggestPot;
          this.startingSoon = startingSoon;
        });
      }
    },
    getQueryParams: function () {
      let params = {};
      try {
        const search = window.location.search.substring(1);
        if (search) {
          const pairs = search.split('&');
          pairs.forEach(pair => {
            const [key, value] = pair.split('=');
            params[key] = decodeURIComponent((value || '').split() || '');
          });
        }
      } catch (error) {
        params = {};
        console.log('Error getting query params. ', error);
      }
      return params;
    }
  },
  computed: {
    corporateChallengeUrl: function() {
      return window.location.origin + this.corporate_challenge_url;
    }
  },
  created: function() {
    this.$store.commit('resetChallengeList');

    var self = this;
    // eslint-disable-next-line no-undef
    var challengeDirCall = $.ajax({
      type: 'GET',
      contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
      url: CHALLENGE_DIRECTORY_API_URL,
      dataType: 'json',
      async: true
    });
    // eslint-disable-next-line no-undef
    var challengeDirV9Call = $.ajax({
      type: 'GET',
      url: CHALLENGE_DIRECTORY_API_V9_URL,
      dataType: 'json'
    });
    // eslint-disable-next-line no-undef
    $.when( // Call in parallel
      challengeDirCall, // Get data for the header and corporate link
      challengeDirV9Call // Get data for the challenges list
    ).done(function(response1, response2) {
      var data1 = response1[0];
      var data2 = response2[0];
      self.corporate_challenge_url = data1.corporate_challenge_url;
      self.hwagerExclude = data1.hwager_exclude;
      self.nyop_challenge = data1.nyop_challenge;
      // eslint-disable-next-line no-undef
      HW.ChallengeDirectoryHeader(data1);
      self.$store.commit('updateChallengeList', data2);
      self.dataLoaded = true;

      const params = self.getQueryParams();
      if (params) {
        self.setFiltersInitialFilters(params);
      }
    }).fail(function(error) {
      console.error(error);
    });
  }

}

export function flatten(list) {
  return [].concat.apply([], list);
}

</script>
